/** Largest playhead jump still treated as playback rather than a scrub (spec 074). */
export const FOREGROUND_SEEK_GAP_SECONDS = 1.5;

export const THEORY_CONSUMPTION_RATIO = 0.8;

export type PlaybackSample = {
  foregroundSeconds: number;
  lastMediaTime: number | null;
};

/**
 * Adds only small, visible, unpaused playhead steps. Background time and seeks do not count.
 */
export function accumulateForegroundPlayback(
  sample: PlaybackSample,
  currentTime: number,
  visible: boolean,
  paused: boolean
): PlaybackSample {
  if (!Number.isFinite(currentTime)) {
    return sample;
  }
  if (!visible || paused || sample.lastMediaTime == null) {
    return { foregroundSeconds: sample.foregroundSeconds, lastMediaTime: currentTime };
  }
  const delta = currentTime - sample.lastMediaTime;
  const foregroundSeconds =
    delta > 0 && delta <= FOREGROUND_SEEK_GAP_SECONDS
      ? sample.foregroundSeconds + delta
      : sample.foregroundSeconds;
  return { foregroundSeconds, lastMediaTime: currentTime };
}

/**
 * Qualifies at 80% of foreground playback, or when the learner plays through to the end
 * in the foreground. A seek to the end does not qualify.
 */
export function playbackQualifies(
  foregroundSeconds: number,
  duration: number,
  ended: boolean
): boolean {
  if (!Number.isFinite(foregroundSeconds) || foregroundSeconds <= 0) {
    return false;
  }
  if (Number.isFinite(duration) && duration > 0) {
    if (foregroundSeconds / duration >= THEORY_CONSUMPTION_RATIO) {
      return true;
    }
    return ended && foregroundSeconds >= duration - FOREGROUND_SEEK_GAP_SECONDS;
  }
  return ended;
}
